import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingEventAmountGroup  {
    _originalTypeClassName = "zERP.BO.AccountingEventAmountGroup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingEventAmountGroup.translate = translateService;
}
this.Amounts = [];
this.Journal = new Domain.AccountingJournal();
this.Id = null;
this.Name = null;
this.IsMultiple = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
IsMultiple:any;
Amounts:any;
Ledger:any;
Journal:any;
static setAmounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Amounts == null) $this.Amounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Amounts.length > 0) {
                    Domain.AccountingEventAmountGroup.removeAmounts($this, $this.Amounts[0]);
                }

                Domain.AccountingEventAmountGroup.addManyAmounts($this, copyItems);
            }
static addManyAmounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingEventAmountGroup.addAmounts($this, items[i]);
                }
            }
static addAmounts = ($this, item) => {
                if ($this.Amounts == null) $this.Amounts = [];
                if (item == null || $this.Amounts.indexOf(item) > -1) return;
                $this.Amounts.push(item);
}
static addRangeAmounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingEventAmountGroup.addAmounts($this, item));
            }
static removeAmounts = ($this, item) => {
                if ($this == null || $this.Amounts == null || $this.Amounts.indexOf(item) === -1) return;
                var _index = $this.Amounts.indexOf(item);
                $this.Amounts.splice(_index, 1);
}
static clearAmounts = ($this) => { $this.Amounts = null; }
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setJournal = ($this, value) => {
var oldValue = $this.Journal;
$this.Journal = value;
if (value != null) {
}
}

static FlattenAmmounts(groups: any): any{return Joove.Common.cast(groups?.linq?.selectMany((g) => g?.Amounts)?.toArray(), "System.Collections.List");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}